import { MedicationOutlineIcon } from './MedicationOutlineIcon';

/**
 * author: Google
 * id 8C286097-F93C-490C-A01F-BB1445A6953C
 * name medication-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/medication-outline.svg
 * tags
 * - Health / Beauty 
 * - Medical / Hospital 
 */
export const MedicineBottleOutlineIcon = MedicationOutlineIcon;
export default MedicineBottleOutlineIcon